
import React, { FunctionComponent } from "react";
import { CollectionPreviewData } from "../../../data/services/run-preview-service";
import isEmpty from "lodash/isEmpty"
import { baseSizeString, numberFormatter } from "src/core/utils/numbers";
import { InstrumentType } from "src/data/model/instrument-type-model";

interface Props {
    previews: CollectionPreviewData[]
    instrumentType: InstrumentType
}

export const ZmwsCellPreviewTable: FunctionComponent<Props> = (props: Props) => {
     const { previews, instrumentType } = props

    if (isEmpty(previews)) {
        return null
    }
    return (
        <div style={{backgroundColor: "#F5F5F5"}} className="mt-3">
            { previews.map( (preview) => (
                <table className="table table-sm table-hover" key={preview.basicOrFull + "|" + preview.collectionId}>
                    <thead>
                        <tr className="bg-white text-dark small">
                            <th colSpan={2}>
                                {`Preview at ${preview.time} hrs`} <small> (estimates) </small>
                            </th>
                        </tr>
                    </thead>
                    <tbody style={{fontSize: "0.8rem"}}>
                        {preview.basicOrFull === "Basic" &&
                            <tr>
                                <th scope="row">{ instrumentType === "Vega" ? "Loading Level" : "P1"}</th>
                                <td> {`${numberFormatter(preview.p1, 0)}%`} </td>
                            </tr>
                        }
                        {preview.basicOrFull === "Full" &&
                            <tr>
                                <th scope="row">HiFi yield</th>
                                <td> {baseSizeString(preview.estimatedYeild,1)} </td>
                            </tr>
                        }
                        <tr>
                            <th scope="row">HiFi read length, mean</th>
                            <td> {baseSizeString(preview.meanLength,1)} </td>
                        </tr>
                        {preview.basicOrFull === "Full" &&
                            <tr>
                                <th scope="row">HiFi read quality, median</th>
                                <td> {numberFormatter(preview.meanHiFiQuality, 0)} </td>
                            </tr>
                        }
                    </tbody>
                </table>
            ))}
        </div>
    )
}
